import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { FetcherError } from '#pplx/frontend/fetcher/errors.js';
export const keepCacheOnError = (error) => {
    // FetcherError is a timeout or local network issue. ApiClientsError with a 5xx status is our
    // backend failing. ApiClientsError with a 429 status is a rate limit error. Don't clear the
    // cache, and be resilient to the failure if we have the last data in the cache.
    return (error instanceof FetcherError ||
        (error instanceof ApiClientsError && (error.status >= 500 || error.status === 429)));
};
//# sourceMappingURL=utils.js.map